import { GlobeIcon } from 'lucide-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import Logo from '../Logo';
import {
  DropDownContainer,
  DropDownHeader,
  DropDownList,
  DropDownListContainer,
  ListItem,
  StyledHeaderContainer,
} from './NavBar.styles';

const NavMenu = (): JSX.Element => {
  const { locale } = useParams();
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const onLanguageChange = (lang: string) => {
    if (lang === locale) return;
    const newUrl = location.pathname.replace(locale ?? '', lang);
    console.log('newUrl: ', newUrl);
    navigate(newUrl);
    i18n.changeLanguage(lang);
  };

  useEffect(() => {
    if (!['it', 'en'].includes(locale ?? '')) {
      i18n.changeLanguage('it');
    }
    console.log('location: ', location);
    console.log('navigate: ', navigate);
  }, [locale]);

  return (
    <StyledHeaderContainer>
      <Logo defaultType="tenant" />
      <DropDownContainer>
        <DropDownHeader user="tenant">
          <GlobeIcon />
          {locale && locale?.toUpperCase()}
        </DropDownHeader>
        <DropDownListContainer>
          <DropDownList>
            <ListItem
              user="tenant"
              onClick={onLanguageChange.bind(null, 'it')}
              key={Math.random()}
            >
              IT
            </ListItem>
            <ListItem
              user="tenant"
              onClick={onLanguageChange.bind(null, 'en')}
              key={Math.random()}
            >
              EN
            </ListItem>
          </DropDownList>
        </DropDownListContainer>
      </DropDownContainer>
    </StyledHeaderContainer>
  );
};

export default NavMenu;
